import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import useOnClickOutside from "use-onclickoutside";

import * as actionTypes from "../../store/actions/actionTypes";
import Admission_MhrImage from "../Lifehouse/Admission_MhrImage";
import AdmissionDocumentPdf from "../AdmissionDocumentPdf";
import Diff from "./Blocks/Diff";
import {CUSTOM_LOGIC_AURORA, CUSTOM_LOGIC_FORTIUS, CUSTOM_LOGIC_JMPH, useCustomLogic} from "../../utils/customLogic";
import DownloadAdmissionDocumentPdf from "../UI/DownloadAdmissionDocumentPdf";
import AdmissionDocumentCleanPdf from "../UI/AdmissionDocumentCleanPdf";
import AdmissionDocumentCleanHtml from "../UI/AdmissionDocumentCleanHtml";
import PdfEmrViewToggle from "../UI/PdfEmrViewToggle";

const ModalAdmissionRegDiff = () => {
    const dispatch = useDispatch();
    // TODO: ACA-638 - clean up dirty code - flag emrView is wrong way
    const {show, admission, data, emrView, search, emrPdfToggle} = useSelector(state => state.modal.adm_reg_diff);
    // the manager clicked through to the data listing, so the PDF side of the switch is opt-in
    const [pdfView, setPdfView] = useState(false);
    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());
    const {isCustomLogicJMPH, isCustomLogicFortius, isCustomLogicStLuke, selectedHospitalCustomLogic} = useCustomLogic();

    const hideModal = () => dispatch({type: actionTypes.MODAL_ADM_REG_DIFF_HIDE});

    const renderStatus = () => {
        switch (data.document.status) {
            case "STATUS_NEW":
                return (
                    <div className="medical-history-signed-at-block">Not viewed by patient</div>
                )
            case "STATUS_VIEWED":
            case "STATUS_NEXT":
            case "STATUS_CUTOFF":
                return (
                    <div className="medical-history-signed-at-block">Viewed by patient</div>
                )
            case "STATUS_COMPLETED":
                return (
                    <div className="medical-history-signed-at-block">Completed by {(data.document.signedByManager) ? 'staff member (' +data.document.signedByManager+')' : 'patient'} at {data.document.completedAt}</div>
                )
        }
    }

    const row1Title = () => {
        switch (selectedHospitalCustomLogic()) {
            case CUSTOM_LOGIC_JMPH:
            case CUSTOM_LOGIC_AURORA:
                return 'Original (Existed in PAS)';
            case CUSTOM_LOGIC_FORTIUS:
                return 'Original (Existed in FYDO)';
            default:
                return 'Original (Existed in Meditech)';
        }
    }

    const title = emrView ? 'EMR VIEW' : 'Admission Information';

    // hospitals without the switch keep the plain download button
    const renderHeaderPdfControl = () => emrPdfToggle
        ? <PdfEmrViewToggle pdfView={pdfView} onChange={setPdfView} extraClass="mr-3"/>
        : <DownloadAdmissionDocumentPdf doc={data.document} extraClass="mr-3"/>

    const renderContent = () => {
        if (!pdfView) {
            return <Diff data={data} row1Title={row1Title()} emrView={emrView} search={search}/>
        }
        // an overlay layout exists as HTML only - its clean PDF is the booklet
        if (data.document && data.document.cleanOverlay) {
            return <AdmissionDocumentCleanHtml documentId={data.document.id}/>
        }
        if (data.document && data.document.cleanPdf) {
            return <AdmissionDocumentCleanPdf documentId={data.document.id}/>
        }

        return <AdmissionDocumentPdf admissionId={admission.id} type={actionTypes.ADMISSION_DOCUMENT} subType={data.document.id}/>
    }

    const renderModal = () => {
        if (show) {
            return <div ref={ref} className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body modal-cols-holder">
                        <div className="content-holder">
                            <div className="modal-header">
                                <h5 className="modal-title h1">{title} for {admission.name} {admission.surname}</h5>
                                {/*{emrView && <_Search />}*/}
                                {renderHeaderPdfControl()}
                                {!isCustomLogicJMPH() && !isCustomLogicFortius() && !isCustomLogicStLuke() && <Admission_MhrImage admission={admission}/>}
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                        onClick={hideModal}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {!emrView && !pdfView && renderStatus()}

                            <div className="modal-admission-info-content scroll-600">
                                {renderContent()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    }

    return (
        <div className={`modal modal-med-history modal-single-column fade ${show ? 'show' : ''}`} id="modalAdmissionInfo" tabIndex="-1" role="dialog"
             style={{display: "block", paddingRight: "11px"}} ariaModal="true">
            {renderModal()}
        </div>
    )
}

const _Search = () => {
    const dispatch = useDispatch();
    const { search} = useSelector(state => state.modal.adm_reg_diff);

    const handleChange = (event) => dispatch({type: actionTypes.MODAL_ADM_REG_DIFF_SEARCH, search: event.target.value});

    return <>
        <div className="input-row">
            <input type="search" className="form-control" placeholder="Search..."
                   onChange={handleChange}
                   value={search}
            />
        </div>
    </>
}

export default ModalAdmissionRegDiff;